import styled from 'styled-components';
export const Close = styled.div.withConfig({
  displayName: "Close",
  componentId: "sc-1kmkg9v-0"
})(["position:absolute;z-index:9000;top:28px;right:18px;width:36px;height:36px;padding:6px;cursor:pointer;text-align:center;svg{position:relative;z-index:1;color:", ";}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.primaryD;
});